import React from 'react';

const SaveTheChildrenLink = (link: string, text: string) => {
    return(<><b><a href="#" target="_blank" onClick={(e) => {
        e.preventDefault();
        window.open(link);
    }}>{text === undefined ? link : text}</a></b></>);
}
export default SaveTheChildrenLink;